function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x01.03.-Studenta-port\\u0101ls---Pieejams-teorijas-eks\\u0101mens---Izv\\u0113l\\u0113ties-dienu-un-laiku---Forma",
  transform: "translate(-403.000000, -185.000000)",
  fill: "#079DC1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(383.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Next-session",
  transform: "translate(0.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(20.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M11,2 C6.02943725,2 2,6.02943725 2,11 C2,15.9705627 6.02943725,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 Z M11,6 C11.5128358,6 11.9355072,6.38604019 11.9932723,6.88337887 L12,7 L12,10 L15,10 C15.5128358,10 15.9355072,10.3860402 15.9932723,10.8833789 L16,11 C16,11.5128358 15.6139598,11.9355072 15.1166211,11.9932723 L15,12 L11,12 C10.4871642,12 10.0644928,11.6139598 10.0067277,11.1166211 L10,11 L10,7 C10,6.44771525 10.4477153,6 11,6 Z",
  id: "Shape"
}))))))));

function SvgIcClockBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15AAE090-468E-4ABF-83A3-C89D42E0A8DB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockBlue);
export default __webpack_public_path__ + "static/media/ic-clock-blue.63618503.svg";
export { ForwardRef as ReactComponent };